export default __webpack_public_path__ + "static/media/random-h-2.f4dbc616.jpg";